import { useSelector } from 'react-redux'

const useLoadingStatus = (key) => useSelector((state) => state.loading[key])

export default useLoadingStatus
